import { request } from "../../../config/helpers/axios-instance";

const GetAllPayments = async (params, queryParams = '') => {
    return request({
        url: `payment/admin${queryParams}`,
        method: "GET",
        params,
    });
};

export default GetAllPayments;
